import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/NotFound404.css';

const NotFound404 = () => {
  const navigate = useNavigate();
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isMouseMoving, setIsMouseMoving] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
      setIsMouseMoving(true);
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className="not-found-container">
      <div
        className="dot-pattern"
        style={{
          WebkitMaskImage: `radial-gradient(circle 300px at ${mousePosition.x}px ${mousePosition.y}px, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))`,
          maskImage: `radial-gradient(circle 300px at ${mousePosition.x}px ${mousePosition.y}px, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))`,
          opacity: isMouseMoving ? 1 : 1,
        }}
      ></div>
      <div className="content">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-message">
        You seem lost, soldier.
        </p>
        <p className="not-found-subtext">Sometimes our quest for knowledge leads us to paths unknown. <br></br>
        No worries, getting lost is the beginning of all knowledge.</p>
        <button onClick={() => navigate('/')} className="custom-button">
          <span className="button-text">Take me Home</span>
          <span className="arrow-container">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="arrow-icon"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </span>
        </button>
      </div>
    </div>
  );
};

export default NotFound404;
